import { render, staticRenderFns } from "./CommunicationsProcessMenus.vue?vue&type=template&id=15415458&scoped=true"
import script from "./CommunicationsProcessMenus.vue?vue&type=script&lang=js"
export * from "./CommunicationsProcessMenus.vue?vue&type=script&lang=js"
import style0 from "./CommunicationsProcessMenus.vue?vue&type=style&index=0&id=15415458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15415458",
  null
  
)

export default component.exports